import styleConfig from '../../muiTheme';

const styles = () => {
  const {
    palette: {
      primary: { main },
      white,
    },
  } = styleConfig;

  return {
    iconBtn: {
      color: white,
    },
    SvgIcon: {
      color: white,
      height: 23,
      width: 23,
    },
    dialog: {
      backgroundColor: main,
      padding: '0 0 0 15px',
    },
    pTag: {
      color: white,
      flex: 1,
      padding: 0,
      fontSize: 16,
      margin: 0,
    },
    mainDiv: {
      display: 'flex',
      alignItems: 'center',
    },
    dialogContent: {
      padding: 20,
      flexDirection: 'column',
    },
    contentTextStyle: {
      color: '#3a3a3a !important',
    },
    buttonWrapper: {
      display: 'flex',
      justifyContent: 'space-around',
      marginLeft: 'calc(100% - 200px)',
      minWidth: 200,
    },
    btn: {
      margin: '16px 0 0',
      backgroundColor: `${main} !important`,
    },
    dialogActions: { margin: 0 },
  };
};

export default styles;
